import * as React from 'react';

import './style.scss';

interface Props {
  label: string;
  onButtonClick: (e: React.FormEvent<HTMLButtonElement>) => any;
}

const ButtonForm = (props: Props) => {
  return(
    <button
      className='primary-button search-button text-center search-text'
      onClick={props.onButtonClick}>
      {props.label}
    </button>
  );
};

export default ButtonForm;
